/**
 * Schedule API Contract
 *
 * Mirrors: backend/src/routes/schedule.routes.ts + schedule.warnings.routes.ts
 * 1:1 parity with existing Express routes
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { PeriodSchema, ScheduleResponseSchema, SalesDataStubResponseSchema, } from "@hourly/api/schedule";
import { ScheduleWarningsResponseSchema } from "@hourly/api/scheduleWarnings";
/**
 * GET /schedule
 * Get schedule for a location
 */
export const getSchedule = oc
    .route({
    method: "GET",
    path: "/schedule",
    summary: "Get schedule for a location",
    tags: ["Schedule"],
})
    .input(z.object({
    locationId: z.uuid(),
    startDate: z.iso.datetime(),
    period: PeriodSchema,
}))
    .output(ScheduleResponseSchema);
/**
 * GET /schedule/sales-data
 * Get sales data (stub - returns empty data)
 */
export const getSalesData = oc
    .route({
    method: "GET",
    path: "/schedule/sales-data",
    summary: "Get sales data for scheduling",
    tags: ["Schedule"],
})
    .input(z.object({
    startDate: z.iso.datetime(),
    endDate: z.iso.datetime(),
}))
    .output(SalesDataStubResponseSchema);
/**
 * GET /schedule/warnings
 * Get schedule warnings for a location
 */
export const getWarnings = oc
    .route({
    method: "GET",
    path: "/schedule/warnings",
    summary: "Get schedule warnings for a location",
    tags: ["Schedule"],
})
    .input(z.object({
    locationId: z.uuid(),
    startDate: z.iso.datetime(),
    period: PeriodSchema,
}))
    .output(z.object({
    data: ScheduleWarningsResponseSchema.nullable(),
    alertsDisabled: z.boolean(),
}));
// ============================================
// Contract Router
// ============================================
export const scheduleContract = {
    getSchedule,
    getSalesData,
    getWarnings,
};
//# sourceMappingURL=schedule.js.map